<template>
  <div class="scroll box" id="app" >
    <div id="home" class="page">
      <div class="header" style="height: 100vh;">
        <!-- 主页轮播图 -->

        <el-carousel
          :interval="3000"
          arrow="always"
          class="carousel"
          style="height: 100%; width: 100%"
          v-model="currentIndex"
        >
          <el-carousel-item v-for="(item,index) in photos" :key="index">
            <!-- <p>文字</p> -->
            <div class="caption" v-html="item.maxTitle"></div>
            <img :src="item.url" class="imgSetting" style="width: 100%;" />
          </el-carousel-item>
        </el-carousel>

        <!-- 导航条 -->
        <div
          class="nav" 
          :class="{ 'nav-fixed': navBarFixed }"
          :style="[{}]"
          style="display: flex; align-items: center; justify-content: space-between;border-bottom: 1px solid rgb(35,35,35);"
        >
          <!-- 图标 -->
          <div
            class="logo-nav"
            style="
              color: white;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              flex: 1;
            "
          >
            <img
              style="width: 270px; "
              src="../assets/2309.png"
              alt=""
            />
            <!-- <span style="font-size: 28px;
            padding-left: 5px;
                  color: #ccc;
                  font-weight: bolder;
                  margin-left: 10px;
                  letter-spacing: 8px;">云中盖娅</span> -->
          </div>

          <!-- 导航菜单 -->
          <div class="nav-out" style="flex: 1; line-height: 55px; position: relative;     display: flex;
              align-items: center;
              justify-content: center;" >  <!--left: 10%; --> 
            <span id="line"></span>
            <!-- <nav> -->
              <!-- @click="clickAnimate" -->
              <a
                v-for="item in list"
                @click="clickAnimate"
                :href="item.href"
                :key="item.id"
                class="nav-link active"
                >{{ item.name }}</a>
            <!-- </nav> -->
          </div>
        </div>
      
      </div>

    </div>

    <!-- <div class="nav-placeholder" v-if="navBarFixed"></div> -->

    

    <div class="pages">
      <!-- 技术优势 -->
      <tech 
        class="page"
        style="height: 1100px; padding-top: 50px ;"
        id="product"
      ></tech>
      <!-- 新闻中心 -->
      <news 
        class="page"
        id="news"
        style="height: 1230px; padding-top: 100px ;"
      ></news>
      <!-- 关于我们 -->
      <abount
        class="page"
        id="about"
        style="height: 950px; padding-top: 100px"
      ></abount>
      <!-- 底部导航 -->
      <bottom></bottom>
    </div>
  </div>
</template>

<script>
import tech from "./Tech.vue";
import news from "./News.vue";
import abount from "./abount.vue";
import $ from "jquery";
import { mapActions } from "vuex";
import bottom from './bottom.vue';
import headerLogo from '../assets/header-logo.png'
// import backgroud from ''

import footerBg1 from '../assets/footer-bg1.jpg'
import footerBg2 from '../assets/footer-bg2.jpg'
import footerBg3 from '../assets/footer-bg3.jpg'
import footerBg4 from '../assets/footer-bg4.jpg'
import axios from "axios";
import {selectPic} from '../utils/api.js'
import '/public/js/script'

export default {
  name: "HomeView",
  data() {
    return {
      currentIndex: 0, // 当前轮播图的索引
      // navBgColor: '', // 原始背景色
      // navBgColorFixed: 'rgb(28, 28, 28)', // 吸顶时的背景色
      activeName: 'tab0', // 使用第一个标签作为初始激活状态
      tabPosition: "right",
      windowHeight: window.innerHeight,
      cliHeight:0,
      cliWight:0,
      navBarFixed: false,
      photos: [],
      isHome: true, 
      scorllTopNum:null,
      list: [
        {
          id: 0,
          href: "#home",
          name: "首页",
        },
        {
          id: 1,
          href: "#product",
          name: "产品介绍",
        },
        {
          id: 2,
          href: "#news",
          name: "新闻中心",
        },
        {
          id: 3,
          href: "#about",
          name: "关于我们",
        },
      ],
      // captions: ['所建，即所念', '拥有系统仿真能力的体系仿真', '低门槛的智能联合仿真','通过AI使OODA在仿真平台中闭环','也许是性能最优的自主仿真引擎'] 
    };
  },
  components: { tech, news, abount, bottom },
  created(){
    this.load()
    // window.addEventListener('resize', this.calculateImageStyles);
  },
  destroyed() {
    // 移除窗口大小变化事件监听器，防止内存泄漏
    // window.removeEventListener('resize', this.calculateImageStyles);
  },
  mounted() {
    // 页面加载时读取状态
    const navState = sessionStorage.getItem('navState') || 'normal'
    
    // this.load()
    // console.log(window.innerHeight,'高度')
    window.addEventListener("scroll", this.watchScroll);
    // this.getNav();
    this.isHome = false; // 显示目录导航

    var box = document.getElementById('box');

    window.addEventListener('resize', () => {
      const w = document.documentElement.clientWidth;
      const h = document.documentElement.clientHeight;
      // console.log('页面大小发生了变化', `宽度：${w}`, `高度：${h}`);
      this.cliWight = `${w}`
      this.cliHeight = `${h}`
      // console.log(this.cliWight)

      // console.log(this.calculateImageStyles(this.cliWight,this.cliHeight),   '调用了')
      // this.calculateImageStyles(this.cliWight,this.cliHeight)
     
    });
  },

  computed: {
    
  },

  methods: {
    // 监听尺寸轮播图自适应
    calculateImageStyles(win,hei) {
      // debugger
      // 获取当前窗口的宽度和高度
      // const windowWidth = window.innerWidth;
      // const windowHeight = window.innerHeight;
      
      let w = parseInt(win)
      let h = parseInt(hei)

      // 设置默认的宽度和高度
      let width = '100%';
      let height = '100%';

      // 如果窗口宽度足够大，根据需要设置高度
      if (w < h) {
        width = 'auto'; // 设置宽度自适应
      }

      // 如果窗口高度足够大，根据需要设置宽度
      if (w > h) {
        height = 'auto'; // 设置高度自适应
      }
      console.log(width,height)
      $('.imgSetting').css({'width': width,"height":height})
    },
    
    //轮播图
    load(){
      selectPic().then(res => {
        // console.log(res)
        if(res.code === 200){
          this.photos= res.data
          // console.log(this.photos)
        }
      })
 
    },
    handleClick(tab) {
      // console.log(tab)
    },
    //滑动页面高亮显示
    getNav() {
      const io = new IntersectionObserver(
        (entries) => {
          console.log(entries)
          let entry = entries.reduce((a, b) => {
            return a.intersectionRatio > b.intersectionRatio ? a : b;
          });
          //获得id
          let id = entry.target.getAttribute("id");
          console.log(id);

          // 查找对应的item
          const targetItem = this.list.find((item) => item.href === `#${id}`);

          if (targetItem) {
            const targetLink = document.querySelector(`a[href="#${id}"]`);
            console.log(document.querySelector(`a[href="#news"]`))
            console.log(targetLink)
            let asd =  document.querySelector('.logo-nav')
            const containerOffset = targetLink.parentElement.offsetLeft;
            const activeOffset = targetLink.offsetLeft - containerOffset;
            debugger
            $("#line").animate(
              {
                left: activeOffset +  asd.offsetWidth,
                width: targetLink.offsetWidth,
              },
              100
            );
          }
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 0.6,
        }
      );

      const pages = document.querySelectorAll(".page");
      pages.forEach((page) => {
        io.observe(page);
      });
    },
    //点击导航条高亮特效
    clickAnimate(event) { 
      const targetLink = $(event.target);
      console.log(targetLink)
      // debugger;
      targetLink.addClass("active").siblings().removeClass("active");
      let asd =  document.querySelector('.logo-nav')
      const containerOffset = targetLink.parent().left;
      
      const activeOffset = targetLink.offset().left - containerOffset;
      $("#line").animate(
        {
          left: activeOffset + asd.offsetWidth,
          width: targetLink.outerWidth(),
        },
        300
      );
      // $(this).addClass("active").siblings().removeClass("active");
      // var activeOffset = $("a.active").offset().left;
      // debugger
      // $("#line").animate({
      //   left: activeOffset,
      //   width: $("a.active").outerWidth()
      // }, 300);
    },
    //吸顶效果
    watchScroll() {
      // var scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
        // console.log('滚动高度',window.pageYOffset)
        this.scorllTopNum = window.pageYOffset
      // console.log(scrollTop)
      //  当滚动超过 90 时，实现吸顶效果
      // if (scrollTop > this.windowHeight - 55) {
      //   this.navBarFixed = true;
      //   // const element = document.getElementById('nav-header')
      //   // element.style.background('#232323')
      // } else {
      //   this.navBarFixed = false;
      // }
    


    },

    handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    
    const sections = this.list.map(item => document.querySelector(item.href))
    
    let active

    sections.forEach((section, index) => {
      if (scrollTop >= section.offsetTop - 100) {
        active = this.list[index].id
      }
    })
    
    this.activeName = 'tab' + active

    // 当滚动到顶部时,表示在首页
    if(scrollTop === 0) { 
        this.isHome = true 
      } else {
        this.isHome = false
      }

  },

    handleClick(tab) {
      // 处理标签点击事件，如果需要的话
      // 例如，可以更新一些数据或执行其他操作
      const section = document.querySelector(this.list.find(item => item.id === +tab.name.split('tab')[1]).href)
        window.scrollTo({
          top: section.offsetTop,
          behavior: 'smooth' 
        })
    },
    scrollToSection(href) {
      // 滚动到具有指定 href 的部分
      const section = document.querySelector(selector)
        window.scrollTo({
          top: section.offsetTop,
          behavior: 'smooth'
        })
      
    },

  },

  watch: {
    //监听scroll变量，只要滚动条位置变化就会执行方法loadScroll
    scroll: function () {
      this.loadScroll();
    },
    scorllTopNum:function(newVal,oldVal){
      if(newVal > oldVal){
        //向下
        $('.scroll').css("backgroundPosition", '0px ' + (-newVal) + 'px')
      }else{
        //向上
        $('.scroll').css("backgroundPosition",'0px ' + (-oldVal) + 'px')
      }
    },

    currentIndex(newIndex) {
      // 当 currentIndex 改变时，更新文字说明
      // 此处假设 captions 数组的长度与 photos 数组相同
      this.currentIndex = newIndex % this.photos.length;
    },
    navState:function(){
      nav.className = navState
      
    }

  },

};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
}

.directory-nav {
  display: block; 
}

.scroll #home .directory-nav {
  display: none; 
}
/* 轮播图文字 */
.caption {
  position: absolute;
  top: 42%;
  left: 0; 
  width: 100%;
  height: 200px;

  background: rgba(0,0,0,0.5);
  color: #fff;

  text-align: center; 
  display: flex; /* 使用 flex 布局 */
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}

/* 吸顶后导航条变色 */
.nav-fixed {
  background-color: gray; /* 设置吸顶后的背景颜色为灰色 */
}
/* 轮播图 */
.el-carousel__container {
  height: 100% !important;
}
.scroll {
  /* height: 2000px; */
      background-image: url('../../public/back05.jpg');
      /* background-position: center top; */
      background-position: 0 100px;
      background-size: auto 20%;
}
.header {
  height: 90px;
  /* background: red; */
  text-align: center;
  color: #fff;
}
.nav {
  position: fixed;
  bottom: 0;
  /* padding: 15px; */
  width: 100%;
  box-sizing: border-box;
  /* background: rgba(8, 15, 42); */
  text-align: left;
  height: 55px;
  z-index: 100; /* 使导航条在其他内容上层显示 */
}
.navBarWrap {
  position: fixed;
  top: 0;
  z-index: 999;
}

/* 菜单横向排列 */
.horizontal-menu {
  list-style: none;
  display: flex; /* 使用 Flexbox 布局 */
  padding: 0;
}

.menu-item {
  margin-right: 20px; /* 调整菜单项之间的间距 */
}

.nav-link {
  text-decoration: none;
  color: #ccc;
  padding: 10px 20px;
}

.nav-link:hover {
  color: #fff; /*设置悬浮效果*/
}

.active{
  /* background-color: rgb(8, 15, 42) !important; */
}

/* 导航跳转选项a */
nav a {
  color: #ccc;
  margin: 0 15px;
  text-decoration: none;
}
/* 选中是显示下划线 */
nav a:hover {
  color: #fff;
}
#line {
  position: absolute;
  /* top: 0; */
  top: 15px;
  left: 0;
  width: 40px;
  height: 3px;
  background-color: #384476;
  /* color: #384476; */
  background-color: #384476;
  background-color: #384476;
  background-color: #384476;
  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.nav-placeholder {
  height: 55px;
}

.imgHover:hover {
  background-color: #6f599c;
}

.el-carousel__indicators--horizontal{
  bottom: 80px !important;
}

.active--top {
  position: fixed;
  top: 0;
  background-color: rgb(28, 28, 28);
}
.active--bottom {
  position: relative;
  bottom: 55px;
  background-color: rgba(35, 35, 35, 0.2);
}


</style>
